export { default } from './getStylesCreator';


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/styles/esm/getStylesCreator/index.js
// module id = 7385
// module chunks = 2